import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { SnackbarErrorComponent } from './snackbar-error.component';

@NgModule({
	declarations: [SnackbarErrorComponent],
	imports: [MatButtonModule, MatIconModule],
	providers: [
		{
			provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
			useValue: { duration: 0, horizontalPosition: 'start', verticalPosition: 'bottom' },
		},
	],
	// exports: [
	// 	MatSnackBarModule
	// ]
})
export class SnackbarErrorModule {}
